export const CARD_FEE_RATE = 0.053;
export const BANK_ACCOUNT_NUMBER = '6274018942';
export const BANK_WHATSAPP_NUMBER = '2205423107';

export function processingFeeFor(method: string, amount: number): number {
  return method === 'card' ? Number((amount * CARD_FEE_RATE).toFixed(2)) : 0;
}

export function canUsePreviewPayment(isAdmin: boolean): boolean {
  return isAdmin === true;
}

export function canCompleteTransfer(whatsappOpened: boolean, submitting: boolean): boolean {
  return whatsappOpened && !submitting;
}

export function transferOrderState() {
  return { payment_method: 'bank_transfer', payment_status: 'pending', status: 'pending_confirmation' };
}